import React from 'react';

export const getStyles = (isCollapsed: boolean, maxHeight?: number): React.CSSProperties => {
    const transitionLength = '200ms';
    const transitionCurve = 'cubic-bezier(0.33, 0.0, 0.1, 1.0)';

    const baseProps = {
        overflow: 'hidden',
        opacity: '100%',
        transition: `max-height ${transitionLength} ${transitionCurve}, opacity 0ms linear ${transitionLength}`,
    };

    const animatingProps = maxHeight !== undefined ? { maxHeight: maxHeight } : undefined;

    const collapsedProps = isCollapsed
        ? {
              maxHeight: '0px',
              opacity: '0%',
              transition: `max-height ${transitionLength} ${transitionCurve}, opacity 0ms linear 0ms`,
          }
        : undefined;

    return {
        ...baseProps,
        ...animatingProps,
        ...collapsedProps,
    };
};
